import styled, {css} from 'styled-components';
import {BGImageCenter, BRIGHT_YELLOW, DEFAULT_COLOR, desktopMedia, mobileMedia, NEON_GREEN, TURQUISE_BLUE, unStyledButton, VERY_DARK_GRAY, WHITE} from '../../../globalVariables/GlobalVariables';
import {btn} from '../../../component/button/btn/Btn.css';
import {copy} from '../../../component/copyLink/CopyLink.css';
import {alignEnd, alignStart, dFlex, dFlexBetween, dFlexCenter, dFlexStart, flexColumn, flexRowReverse, justifyAround, justifyBetween, justifyStart} from '../../../globalVariables/GlobalFlex';
import {STATIC_IMAGE} from '../../../config/config';

export const confirmationBox = styled.div`
  background-color: ${TURQUISE_BLUE}24;
  border-radius: 10px;
  padding: 24px;
  margin-bottom: 24px;
  min-height: 345px;
`;
export const confirmationBoxFlexStart = styled(confirmationBox)`
  min-height: fit-content;
  ${flexColumn}
  ${dFlexStart}
  ${alignStart};
  margin: 32px 0;
  ${mobileMedia}{
    margin: 20px 0;

  }

`;
export const confirmationBoxFlexEnd= styled(confirmationBox)`
  min-height: 170px;
  ${dFlex}
  ${alignEnd}
`;
export const confirmationBoxFlexCenter = styled(confirmationBox)`
  min-height: 170px;
  ${dFlexCenter}
  ${justifyBetween}
`;
export const rightBox = styled.div`
  width: 65%;
`;
export const confirmationHeader = styled.div`
  ${dFlexBetween}
  ${alignStart}
  ${flexColumn}
  margin-bottom: 16px;
`;
const withMarginStart = css`
  margin-inline-start: 42px;
`;
export const elementWithMargin = styled.div`
  ${desktopMedia}{
    ${withMarginStart}
  }
`;
export const boldText = styled.p`
  margin-top: 2px;
  font-weight: 700;
  text-align: start;
`;
export const boldTextCenter = styled(boldText)`
  text-align: center;
`;
export const title = styled.div`
  font-size: 16px;
  font-weight: 700;
`;
export const titleCenter = styled(title)`
  text-align: center;
`;
export const errorTitle = styled(titleCenter)`
  margin-bottom: 30px;
`;
export const titleStart = styled(titleCenter)`
  text-align: start;
  margin-bottom: 30px;
  width: max-content;
  max-width: 150%;
`;
export const successMessage = styled(titleCenter)`
  margin-top: 43px;
`;

export const ticketInfo = styled.p`
  margin-block: 30px;
`;

export const infoRow = styled.div<{$style?: string}>`
  ${dFlexBetween};
  margin-bottom: 15px;
  max-height: 15px;
  ${copy}{
    font-size: 14px;
    font-weight: normal;
    ${flexRowReverse};
    gap:3px;
  }
  ${p=>p.$style}
`;

export const infoValue = styled.div`
  text-align: center;
`;
export const shareLink = styled(unStyledButton)``;

export const QrCode = styled.div`
  height: 100px;
`;

export const infoIcon = styled.div<{$icon?: string}>`
      width: 17px;
      height: 17px;
      transform: scale(1);
      ${p=>BGImageCenter(p.$icon, '7px')}
`;
export const successIcon = styled(infoIcon)`
      border-radius: 50%;
      background-color: ${NEON_GREEN};
`;
export const shareIcon = styled(infoIcon)`
    background-size: 10px;
`;
export const circleLoader = styled.div`
  margin-inline-end: 24px;
  &>div{
    width: 28px;
    height: 28px;
  }
`;

export const checkboxRow = styled.div`
  ${dFlexCenter}
  ${justifyStart}
  margin-top: 16px;
  gap: 10px;
  .classicCheckbox{
    margin: 0;
  }
`;

export const buttonRow = styled.div`
  ${dFlexCenter};
  gap: 22px;
  margin-bottom: 24px;
  ${mobileMedia}{
    ${flexColumn};
    &.decisionScreen{
      padding-bottom: 150px;
    }

  }
  ${btn}{
      font-weight: 700;
      width: 150px;
      height: 42px;
      background-color: ${BRIGHT_YELLOW};
      border: none;
      &.white {
          background-color: ${WHITE};
          border: 2px solid ${VERY_DARK_GRAY};
      }
      &.LOADING{
        width:42px;
      }
  }
`;

export const ticketLink = styled.div`
  margin: auto;
  width: fit-content;
`;

export const image = styled.img`
  height: 100px;
    max-width: 44%;
    object-fit: contain;
`;

export const blueHeader = styled.div`
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;
  width: calc(100% + 64px);
  height: 190px;
  ${dFlexCenter};
  padding: 2%;
  background-color: ${DEFAULT_COLOR};
  margin: -32px;
  margin-bottom: 33px;
  img{
    max-height: 100%;
    ${mobileMedia} {
      max-height: 80%;

    }
  }
  ${mobileMedia} {
    height: 90px !important;
    margin-inline-start: -15px;
    width: calc(100% + 30px);
    align-items: flex-end;
  }
`;

export const iconsContainer = styled.div`
  ${dFlexCenter};
  margin-top: 40px;
  ${justifyAround}
`;
export const bigIcon = styled.div<{ $iconType: 'Name' | 'Location' | 'Time' }>`
  width: 60px;
  height: 60px;
  margin: 0 auto;
  ${props => BGImageCenter(`${STATIC_IMAGE}/icons/info${props.$iconType}.png`, 'contain')}
`;

